import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteGiveaway = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/briefs/giveaways/main/${id}` });

  return data;
};

export default deleteGiveaway;
